import { render, staticRenderFns } from "./RedeemCoinCard.vue?vue&type=template&id=5eaae505&scoped=true"
import script from "./RedeemCoinCard.vue?vue&type=script&lang=js"
export * from "./RedeemCoinCard.vue?vue&type=script&lang=js"
import style0 from "./RedeemCoinCard.vue?vue&type=style&index=0&id=5eaae505&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eaae505",
  null
  
)

export default component.exports